import { authenticatedFetch } from "@lumi/data";
import { useState } from "react";
import { useAuth } from "../../../auth/AuthContext";
import { createRefreshCallback } from "../../../auth/refreshCallback";

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) || "http://localhost:4000";

interface TriggerEncodingResult {
  message: string;
  assetsProcessed: number;
  assetsFailed?: number;
}

/**
 * Hook for triggering Cloudflare Stream encoding for submission videos
 */
export function useTriggerEncoding(submissionId: string | undefined) {
  const { accessToken, refreshAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const triggerEncoding = async (): Promise<TriggerEncodingResult | null> => {
    if (!submissionId || !accessToken) {
      setError("No submission ID or auth token");
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await authenticatedFetch<TriggerEncodingResult>(
        `${API_BASE}/v1/admin/submissions/${submissionId}/trigger-encoding`,
        {
          method: "POST",
        },
        accessToken,
        createRefreshCallback(refreshAuth),
      );

      return result;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to trigger encoding";
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    triggerEncoding,
    loading,
    error,
  };
}
